import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Api() {
    const navigate = useNavigate();

    const getToken = () => {
        const tokenString = sessionStorage.getItem('token');
        const userToken = JSON.parse(tokenString);
        return userToken;
    }
    const getUser = () => {
        const userString = sessionStorage.getItem('user');
        const user_detail = JSON.parse(userString);
        return user_detail;
    }
    const saveToken = (user, token) => {
        sessionStorage.setItem('token', JSON.stringify(token));
        sessionStorage.setItem('user', JSON.stringify(user));

        setToken(token);
        setUser(user);
        navigate('/pages/dashboard');
    }
    const logout = () => {
        sessionStorage.clear();
        navigate('/pages/form');
    }
    const [token, setToken] = useState(getToken());
    const [user, setUser] = useState(getUser());
    const http = axios.create({
        baseURL: `http://127.0.0.1:8000/api/`,
        headers: {
            "Content-Type": "application/json",
            Authorization:  `Bearer ${token}`,
        },
        withCredentials: true,
    });

    return {
        setToken: saveToken,
        token,
        user,
        getToken,
        http,
        logout
    }
}
